/**
 * Custom hook for managing modal handlers
 */

import { useCallback, useRef } from 'react';

export const useModalHandlers = <T extends string = string>() => {
	const handlers = useRef<Record<T, (() => void) | null>>({} as Record<T, (() => void) | null>);

	const setHandler = useCallback((type: T, handler: (() => void) | null) => {
		handlers.current[type] = handler;
	}, []);

	const callHandler = useCallback((type: T) => {
		const handler = handlers.current[type];
		if (handler) {
			try {
				handler();
			} catch (error) {
				console.error(`Error calling ${type} handler:`, error);
			}
		}
	}, []);

	return { setHandler, callHandler };
};
